
import { Component, Prop, Vue } from "vue-property-decorator";

const CLASS = "notification";

const ALIGN_MIDDLE = "center";

const DIRECTION_ROW = "row";

@Component({})
export default class VNotificationTemplate extends Vue {
  @Prop({ type: String }) readonly icon!: string;
  @Prop({ type: Boolean, default: true }) readonly stretch!: boolean;
  @Prop({ type: String, default: ALIGN_MIDDLE }) readonly align?: string;
  @Prop({ type: String, default: DIRECTION_ROW }) readonly direction?: string;
  @Prop({ type: Boolean, default: false }) readonly transparent?: boolean;
  @Prop({ type: Boolean, default: false }) readonly boldText?: boolean;
  @Prop({ type: Boolean, default: false }) readonly shortTextWidth?: boolean;
  @Prop({ type: String }) readonly color?: string;
  @Prop({ type: String }) readonly background?: string;

  get classes() {
    const {
      stretch,
      align,
      direction,
      transparent,
      boldText,
      shortTextWidth,
      color,
      background,
    } = this;

    return {
      [`${CLASS}_stretch`]: stretch,
      [`${CLASS}_${align}`]: align,
      [`${CLASS}_${direction}`]: direction,
      [`${CLASS}_transparent`]: transparent,
      [`${CLASS}_bold-text`]: boldText,
      [`${CLASS}_short-text-width`]: shortTextWidth,
      [`${CLASS}_color-${color}`]: color,
      [`${CLASS}_background-${color}`]: background,
    };
  }

  get hasControls(): boolean {
    return !!this.$slots["controls"];
  }
}
